import { useContext } from "react";
import { GlobalInfo } from "../Contexts/GlobalContext";
import { Route, Routes } from "react-router-dom";
import PaymentConfirm from "../Pages/Donor/PaymentConfirm";

const PaymentRoutes = ()=>{
    const { isSidebarVisible } = useContext(GlobalInfo);
    
    return (<>
    <div className={`${!isSidebarVisible ? 'collapsed-body' : ''}`}>
         <Routes>
            <Route path="confirm/:token" element={<PaymentConfirm requiredRole="donor" />} />
         </Routes>
    </div>
    </>
    );
}
export default PaymentRoutes;
